import { useRef, useCallback } from 'react';

export const useEvent = (cb) => {
  const cbRef = useRef(cb);
  cbRef.current = cb;

  return useCallback((...args) => {
    const fn = cbRef.current;
    return fn(...args);
  }, []);
};
